<template>
  <div class="projectDetail">
    <div class="top">
      <div class="name">
        <div class="icon">项目<br />名称</div>
        <div class="content">{{ info.projectName }}</div>
      </div>
      <div class="time">
        <div class="icon">项目<br />周期</div>
        <div class="content">
          {{ info.startDate | filterDate }} ~
          {{ info.endDate | filterDate }}
        </div>
      </div>
      <div class="money">
        <div class="icon">项目<br />总额</div>
        <div class="content">￥{{ info.total }}</div>
      </div>
      <div class="manager">
        <div class="icon">项目<br />经理</div>
        <div class="content">{{ info.managerName }}</div>
      </div>
    </div>
    <div class="middle">
      <div class="middleLeft">
        <div class="title">地域范围&任务类型</div>
        <!-- <div
          class="roadItem"
          :class="{ roadItemChoose: item.id === selectRoad.id }"
          v-for="(item, index) in listType"
          @click="chooseRoad(item)"
        >
          <span>{{ item.roadName }}</span>
        </div> -->
        <el-col :span="12">
          <div style="padding: 10px;">
            <el-button type="primary" size="small" @click="showAllTasks" style="width: 100%;">全部（{{ AllTasklist.length }}）</el-button>
          </div>
          <el-menu
            default-active="2"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
          >
            <el-submenu
              :index="index.toString()"
              v-for="(item, index) in listType"
              :key="'submenu-' + index"
              v-if="item.roadName != '总计'"
            >
              <template slot="title">
                <span>{{ item.roadName }}</span>
              </template>
              <el-menu-item-group
                v-for="(group, index) in item.busProjectRoads"
                :key="index"
              >
                <el-menu-item
                  :index="index.toString()"
                  @click="chooseRoad(group)"
                  >{{ truncateText(group.roadName) }}（{{ roadTaskCounts[group.roadId] || 0 }} ）</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item
              v-for="(item, index) in listType"
              :key="'menu-' + index"
              :index="index.toString()"
              @click="chooseRoad(item)"
              v-if="item.roadName == '总计'"
            >
              <span slot="title">{{ item.roadName }}</span>
            </el-menu-item>
          </el-menu>
        </el-col>
      </div>
      <div v-if="selectRoad.id != '' || selectRoad.tag === 'all'" class="middleRight">
        <div class="subMiddle">
          <div class="tab-lead">
            <el-menu
              :default-active="activeIndex"
              class="el-menu-demo"
              mode="horizontal"
              @select="handleSelect"
            >
              <el-menu-item index="1">养护（{{ typeTaskCounts['1'] || 0 }}）</el-menu-item>
              <el-menu-item index="2">检测（{{ typeTaskCounts['2'] || 0 }}）</el-menu-item>
              <el-menu-item index="3">测绘（{{ typeTaskCounts['3'] || 0 }}）</el-menu-item>
              <el-menu-item index="4">抢修（{{ typeTaskCounts['4'] || 0 }}）</el-menu-item>
              <el-menu-item index="5">维修(开挖)（{{ typeTaskCounts['5'] || 0 }}）</el-menu-item>
              <el-menu-item index="6">维修(非开挖)（{{ typeTaskCounts['6'] || 0 }}）</el-menu-item>
            </el-menu>
          </div>
          <!-- 年度筛选标签 -->
          <div v-if="yearScheme" class="year-filter">
            <span class="year-label">年度筛选：</span>
            <el-radio-group v-model="selectedYear" size="small" @change="handleYearChange">
              <el-radio-button label="all">全部年度</el-radio-button>
              <el-radio-button
                v-for="year in allYears"
                :key="year"
                :label="year"
              >{{ year }}年</el-radio-button>
            </el-radio-group>
            <span v-if="yearScheme === 'a'" class="scheme-tag">方案A-项目级年度</span>
            <span v-if="yearScheme === 'b'" class="scheme-tag">方案B-任务级年度</span>
          </div>
          <el-button style="width: 100%" type="primary" @click="addTask"
            >新增任务</el-button
          >
          <div class="task-list-container">
            <div
              style="
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: space-between;
              "
            >
              <!-- 1：进行中  2：待验收  3：已验收 -->
              <div
                class="taskItem"
                :class="{
                  success: item.status === 3,
                  danger: item.status === 1,
                  waring: item.status === 2,
                }"
                v-for="(item, index) in filteredTaskList"
                @click="goToTaskDetail(item)"
                :key="'task' + index"
              >
                <div
                  class="taskStatus"
                  :class="{
                    success: item.status === 3,
                    danger: item.status === 1,
                    waring: item.status === 2,
                  }"
                >
                  {{ item.status | filterStatus }}
                </div>
                <div style="display: flex">
                  <div class="taskType">{{ item.workName }}</div>
                  <div class="taskTime">
                    {{ item.startTime | filterTime }} ~
                    {{ item.endTime | filterTime }}
                  </div>
                </div>

                <el-popover
                  placement="top"
                  trigger="hover"
                  :width="300"
                  popper-class="task-popover"
                >
                  <template #reference>
                    <div class="taskName">
                      {{ item.explains | truncate(12) }}
                    </div>
                  </template>
                  <div class="popover-content">
                    {{ item.explains }}
                  </div>
                </el-popover>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div class="taskType"></div>
                  <div class="taskTypeName">
                    班组长:{{ item.groupManageName }}
                  </div>
                </div>
                <el-button type="primary" @click.stop="showUpdate(item)"
                  >任务转单/延期</el-button
                >
                <el-button type="success" @click.stop="exportTaskSummary(item)"
                  >作业汇总表</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="subRight">
          <div class="title">此地域/类型任务工程量汇总</div>
          <!-- 合同内/外和分年度统计 -->
          <div v-if="yearScheme === 'a'" class="contract-year-summary">
            <!-- 合同内统计 -->
            <div class="contract-section">
              <div class="section-title">合同内工程量</div>
              <div v-for="year in allYears" :key="'contract-' + year" class="year-summary-item">
                <div class="year-label">{{ year }}年</div>
                <div class="year-content">
                  <div v-for="(item, index) in getContractYearQuantity(year)" :key="'contract-item-' + index" class="quantity-item">
                    <div class="item-name">{{ item.workItemName }}</div>
                    <div class="item-value">{{ item.quantity }} {{ item.workItemUnitName }}</div>
                    <div class="item-price">￥{{ (item.quantity * item.price).toFixed(2) }}</div>
                  </div>
                  <div class="year-total">小计: ￥{{ getContractYearTotal(year).toFixed(2) }}</div>
                </div>
              </div>
              <div class="contract-total">合同内总计: ￥{{ getContractTotal().toFixed(2) }}</div>
            </div>

            <!-- 合同外统计 -->
            <div class="contract-section">
              <div class="section-title">合同外工程量</div>
              <div v-for="year in allYears" :key="'extra-' + year" class="year-summary-item">
                <div class="year-label">{{ year }}年</div>
                <div class="year-content">
                  <div v-for="(item, index) in getExtraContractYearQuantity(year)" :key="'extra-item-' + index" class="quantity-item">
                    <div class="item-name">{{ item.workItemName }}</div>
                    <div class="item-value">{{ item.quantity }} {{ item.workItemUnitName }}</div>
                    <div class="item-price">￥{{ (item.quantity * item.price).toFixed(2) }}</div>
                  </div>
                  <div class="year-total">小计: ￥{{ getExtraContractYearTotal(year).toFixed(2) }}</div>
                </div>
              </div>
              <div class="contract-total">合同外总计: ￥{{ getExtraContractTotal().toFixed(2) }}</div>
            </div>

            <!-- 总计 -->
            <div class="grand-total">
              <div class="grand-total-label">项目总计</div>
              <div class="grand-total-value">￥{{ getGrandTotal().toFixed(2) }}</div>
            </div>
          </div>

          <!-- 原有的简单汇总（非方案A时显示） -->
          <div v-else
            v-for="(item, index) in quantityList"
            :kye="'quantityList' + index"
            style="display: flex; flex-direction: row"
          >
            <div style="flex: 3; height: auto; line-height: 30px">
              {{ item.workItemName }}
            </div>
            <div
              style="flex: 1; height: auto; line-height: 30px; font-size: 24px"
            >
              {{ item.quantity }}
            </div>
            <div style="flex: 1; height: auto; line-height: 30px">
              {{ item.workItemUnitName }}
            </div>
            <div
              style="flex: 1; height: auto; line-height: 30px; font-size: 24px"
            >
              ￥{{ item.quantity * item.price }}
            </div>
          </div>
          <div
            v-if="!yearScheme && this.quantityList && this.quantityList.length > 0"
            class="total-class"
          >
            总金额:￥{{ totalAmount }}
          </div>
        </div>
      </div>
      <div v-else class="middleRight">
        <div class="subMiddle">
          <div style="display: flex; flex-direction: row">
            <div class="title" style="flex: 2">项目计划工程量汇总</div>
            <div class="title" style="flex: 2">实际工程量汇总</div>
            <div class="title" style="flex: 1">金额</div>
            <div class="title" style="flex: 1">完成率</div>
          </div>
          <div
            style="display: flex; flex-direction: row"
            v-for="(item, index) in sumList"
            class="title"
          >
            <div style="flex: 2" class="workInfo">
              <div class="workTitle">{{ item.workItemName }}</div>
              <div class="workQuantity">{{ item.jhQuantity }}</div>
              <div class="workUnit">{{ item.workItemUnitName }}</div>
            </div>
            <div style="flex: 2" class="workInfo">
              <div class="workTitle">{{ item.workItemName }}</div>
              <div class="workQuantity">{{ item.quantity }}</div>
              <div class="workUnit">{{ item.workItemUnitName }}</div>
            </div>
            <div style="flex: 1" class="workInfo">
              <div class="workQuantity">￥{{ item.quantity * item.price }}</div>
            </div>
            <div style="flex: 1" class="workInfo">
              <div class="workQuantity">
                {{ ((item.quantity / item.jhQuantity) * 100).toFixed(2) }}%
              </div>
            </div>
          </div>
          <div class="total-class-left">总金额：￥{{ totalAmountOne }}</div>
        </div>
      </div>
    </div>

    <!-- 任务转单/延期弹窗 -->  
    <el-dialog
      title="任务转单/延期"
      :visible.sync="updateDialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form :model="updateForm" label-width="100px">
        <el-row>
          <el-form-item label="任务时长">
            <el-date-picker
              v-model="updateForm.date"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 428px"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="班组">
            <el-radio-group
              :disabled="updateForm.date.length != 2"
              v-model="updateForm.groupId"
              @change="changeGroup"
            >
              <el-radio
                v-for="item in groupList"
                :key="item.id"
                :label="item.id"
                >{{ item.name }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车辆分配">
            <div
              class="carItem2"
              v-for="(item, index) in carList"
              :key="'car2222' + index"
            >
              <div class="carType">
                {{ item.carTypeName }}
              </div>
              <div class="carInfo">
                <div class="carNumber">{{ item.carNum }}</div>
                <div class="carTip">
                  <div class="tips waring" v-if="item.carMark === 0">固</div>
                  <div class="tips primary" v-if="item.carMark === 1">流</div>
                  <div class="tips success" v-if="item.illegalStatus != null">
                    保
                  </div>
                  <div class="tips danger" v-if="item.usageStatus === 2">修</div>
                </div>
              </div>
              <div class="carGroup">
                <div>{{ item.groupName }} - {{ item.driverName }}</div>
                <div
                  style="margin-right: 10px; color: #f56c6c; cursor: pointer"
                  @click="delCar(index)"
                >
                  删除
                </div>
              </div>
            </div>
            <el-button
              style="vertical-align: top; height: 60px"
              type="primary"
              plain
              @click="addCar"
              >+ 新增车辆
            </el-button>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmUpdate">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="carVisible"
      title="选择车辆"
      width="650px"
      @close="closeDialog"
    >
      <div style="display: flex; flex-direction: row">
        <div
          class="type"
          @click="chooseCarType(0)"
          :class="{ choose: type === 0 }"
        >
          固定车辆
        </div>
        <div
          class="type"
          @click="chooseCarType(1)"
          :class="{ choose: type === 1 }"
        >
          流动车辆
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          margin-top: 20px;
        "
      >
        <div
          class="carItem"
          v-for="(item, index) in addCarList"
          :key="'car' + index"
          :class="{
            gray: item.usageStatus != 0,
            choosedCar: item.carId === selectCar.carId,
          }"
          @click="chooseCar(index, item)"
        >
          <div class="carType">
            {{ item.carTypeName }}
          </div>
          <div class="carInfo">
            <div class="carNumber">{{ item.carNum }}</div>
            <div class="carTip">
              <div class="tips waring" v-if="item.carMark === 0">固</div>
              <div class="tips primary" v-if="item.carMark === 1">流</div>
              <div class="tips success" v-if="item.illegalStatus != null">
                保
              </div>
              <div class="tips danger" v-if="item.usageStatus === 2">修</div>
            </div>
          </div>
          <div class="carGroup">
            {{ item.groupName }} - {{ item.driverName }}
          </div>
        </div>
      </div>
      <div style="margin-top: 20px">
        <el-button type="primary" @click="submitCar">确定</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TaskDispatchApi from "@/api/taskDispatch";
import TeamGroupApi from "@/api/teamGroup";
import ProjectApplyApi from "@/api/projectApply";
import CommonUtil from "@/utils/commonUtil";
export default {
  data() {
    return {
      activeIndex: "all",
      info: {},
      detail: {},
      listType: [],
      selectRoad: {},
      taskList: [],
      AllTasklist: [], // 存储所有任务列表
      quantityList: [],
      sumList: [],
      // 筛选参数
      filterParams: {
        region: '', // 地区筛选
        type: ''    // 类型筛选
      },
      // 年度区分方案
      yearScheme: null, // 'a'=方案A项目级, 'b'=方案B任务级
      projectYear: null, // 方案A:项目年度
      projectYears: [], // 方案B:项目多年度
      selectedYear: 'all', // 当前选中的年度筛选
      taskYears: [], // 任务涉及的年度列表
      // 任务转单/延期弹窗相关
      updateDialogVisible: false,
      currentTask: null,
      updateForm: {
        date: [],
        groupId: "",
        groupManageId: "",
        groupManageName: "",
        groupName: ""
      },
      carList: [], // 存储车辆列表
      groupList: [],
      // 车辆选择相关
      carVisible: false,
      selectCar: {},
      type: 0,
      addCarList: [],
    };
  },
  mounted() {
    // 检测年度方案类型
    this.yearScheme = this.$route.query.type || null;
    if (this.yearScheme) {
      console.log('当前年度方案:', this.yearScheme === 'a' ? '方案A-项目级年度' : '方案B-任务级年度');
    }
    this.getDetail();
  },
  computed: {
    totalAmount() {
      return this.quantityList.reduce((sum, item) => {
        return sum + item.quantity * item.price;
      }, 0);
    },
    totalAmountOne() {
      return this.sumList.reduce((sum, item) => {
        return sum + item.quantity * item.price;
      }, 0);
    },
    // 方案A：获取各年度的任务数量
    getYearTaskCount() {
      return (year) => {
        return this.taskList.filter(task => {
          const taskYear = task.year || this.projectYear;
          return String(taskYear) === String(year);
        }).length;
      };
    },
    // 方案A：获取合同内某年度的工程量列表
    getContractYearQuantity(year) {
      // 根据年度筛选任务
      const yearTasks = this.taskList.filter(task => {
        const taskYear = task.year || this.projectYear;
        return String(taskYear) === String(year) && task.contractType === 'in';
      });

      // 统计该年度合同内任务的工程量
      const quantityMap = {};
      yearTasks.forEach(task => {
        if (task.busTaskItems) {
          task.busTaskItems.forEach(item => {
            if (!quantityMap[item.workItemId]) {
              quantityMap[item.workItemId] = {
                workItemId: item.workItemId,
                workItemName: item.workItemName,
                workItemUnitName: item.workItemUnitName,
                quantity: 0,
                price: item.price
              };
            }
            quantityMap[item.workItemId].quantity += item.quantity || 0;
          });
        }
      });

      return Object.values(quantityMap);
    },

    // 方案A：获取合同外某年度的工程量列表
    getExtraContractYearQuantity(year) {
      // 根据年度筛选任务
      const yearTasks = this.taskList.filter(task => {
        const taskYear = task.year || this.projectYear;
        return String(taskYear) === String(year) && task.contractType === 'out';
      });

      // 统计该年度合同外任务的工程量
      const quantityMap = {};
      yearTasks.forEach(task => {
        if (task.busTaskItems) {
          task.busTaskItems.forEach(item => {
            if (!quantityMap[item.workItemId]) {
              quantityMap[item.workItemId] = {
                workItemId: item.workItemId,
                workItemName: item.workItemName,
                workItemUnitName: item.workItemUnitName,
                quantity: 0,
                price: item.price
              };
            }
            quantityMap[item.workItemId].quantity += item.quantity || 0;
          });
        }
      });

      return Object.values(quantityMap);
    },

    // 方案A：获取合同内某年度的总金额
    getContractYearTotal(year) {
      const quantities = this.getContractYearQuantity(year);
      return quantities.reduce((sum, item) => {
        return sum + (item.quantity * item.price);
      }, 0);
    },

    // 方案A：获取合同外某年度的总金额
    getExtraContractYearTotal(year) {
      const quantities = this.getExtraContractYearQuantity(year);
      return quantities.reduce((sum, item) => {
        return sum + (item.quantity * item.price);
      }, 0);
    },

    // 方案A：获取合同内总金额
    getContractTotal() {
      return this.allYears.reduce((sum, year) => {
        return sum + this.getContractYearTotal(year);
      }, 0);
    },

    // 方案A：获取合同外总金额
    getExtraContractTotal() {
      return this.allYears.reduce((sum, year) => {
        return sum + this.getExtraContractYearTotal(year);
      }, 0);
    },

    // 方案A：获取项目总金额
    getGrandTotal() {
      return this.getContractTotal() + this.getExtraContractTotal();
    },
    // 筛选后的任务列表
    filteredTaskList() {
      let result = [...this.taskList];

      // 按类型筛选
      if (this.activeIndex !== 'all') {
        const typeMap = {
          '1': '养护',
          '2': '检测',
          '3': '测绘',
          '4': '抢修',
          '5': '维修(开挖)',
          '6': '维修(非开挖)'
        };
        result = result.filter(item => item.workName === typeMap[this.activeIndex]);
      }

      // 按地区筛选（如果selectRoad有值且不是总计）
      if (this.selectRoad && this.selectRoad.roadId !== '') {
        result = result.filter(item => item.roadId === this.selectRoad.roadId);
      }

      // 按年度筛选
      if (this.yearScheme && this.selectedYear !== 'all') {
        result = result.filter(item => {
          // 优先使用任务的年度字段，否则使用项目年度（方案A）
          const taskYear = item.year || this.projectYear;
          return String(taskYear) === String(this.selectedYear);
        });
      }

      return result;
    },
    // 年度筛选后的工程量统计
    yearFilteredQuantityList() {
      if (!this.yearScheme || this.selectedYear === 'all') {
        return this.quantityList;
      }
      // 根据年度筛选后的任务来统计工程量
      const yearTaskIds = this.filteredTaskList.map(task => task.id);
      return this.quantityList.filter(item => {
        // 这里需要根据任务ID关联工程量数据
        return true;
      });
    },
    // 获取所有涉及的年度列表
    allYears() {
      const years = new Set();
      if (this.yearScheme === 'a') {
        // 方案A：使用项目年度
        if (this.projectYear) {
          years.add(this.projectYear);
        } else {
          // 如果没有项目年度，从项目周期中提取年度
          if (this.info.startDate && this.info.endDate) {
            const startYear = new Date(this.info.startDate).getFullYear();
            const endYear = new Date(this.info.endDate).getFullYear();
            for (let year = startYear; year <= endYear; year++) {
              years.add(year);
            }
          }
        }
      } else if (this.yearScheme === 'b') {
        // 方案B：从任务中提取年度
        this.taskList.forEach(task => {
          if (task.year) {
            years.add(task.year);
          }
        });
        // 如果任务没有年度，使用项目的多年度配置
        if (years.size === 0 && this.projectYears.length > 0) {
          this.projectYears.forEach(y => years.add(y));
        }
      }
      return Array.from(years).sort();
    },
    // 统计各类型的任务数量
    typeTaskCounts() {
      const typeMap = {
        '1': '养护',
        '2': '检测',
        '3': '测绘',
        '4': '抢修',
        '5': '维修(开挖)',
        '6': '维修(非开挖)'
      };
      
      const counts = {};
      // 初始化计数器
      Object.keys(typeMap).forEach(key => {
        counts[key] = 0;
      });
      
      // 筛选出当前选择的道路的任务
      let filteredTasks = [...this.taskList];

      // 如果选择了特定道路，则筛选出该道路的任务
      if (this.selectRoad && this.selectRoad.roadId !== '') {
        filteredTasks = filteredTasks.filter(item => item.roadId === this.selectRoad.roadId);
      }

      // 统计各类型的任务数量
      filteredTasks.forEach(task => {
        Object.keys(typeMap).forEach(key => {
          if (task.workName === typeMap[key]) {
            counts[key]++;
          }
        });
      });
      
      return counts;
    },
    // 统计各道路的任务数量
    // 统计各道路的任务数量
roadTaskCounts() {
  const counts = {};
  
  // 直接统计AllTasklist中每个roadId对应的任务数量
  this.AllTasklist.forEach(task => {
    if (task.roadId) {
      if (counts[task.roadId]) {
        counts[task.roadId]++;
      } else {
        counts[task.roadId] = 1;
      }
    }
  });

  return counts;
}
  },
  filters: {
    filterDate(val) {
      if (val) {
        let date = new Date(val);
        return CommonUtil.parseTime(date, "yyyy-MM-dd");
      }
      return "";
    },
    filterStatus(val) {
      if (val === 0) {
        return "待发布";
      } else if (val === 1) {
        return "进行中";
      } else if (val === 2) {
        return "待验收";
      } else if (val === 3) {
        return "已验收";
      }

      return "";
    },
    filterTime(val) {
      let date = new Date(val.toString().replace(/-/g, "/"));
      return CommonUtil.parseTime(date, "yyyy-MM-dd");
    },
    truncate(value, length) {
      const safeValue = value || "";
      return safeValue.length > length
        ? safeValue.substring(0, length) + "..."
        : safeValue;
    },
  },
  methods: {
    showUpdate(item) {
      console.log(item);

      this.currentTask = item;
      // 重置表单
      this.updateForm = {
        date: [],
        groupId: "",
        groupManageId: "",
        groupManageName: "",
        groupName: ""
      };
      // 获取班组列表
      this.getGroupList();
      // 获取任务详情
      TaskDispatchApi.getTaskDetail({
        current: 1,
        size: 10,
        taskId: item.id,
        //projectId: this.$route.query.pid
      }).then((res) => {
        if (res.data.code === 200) {
          const taskDetail = res.data.data;
          console.log("任务详情:", taskDetail);
          console.log("所有作业数据(busTaskItems):", taskDetail.busTaskItems);
          console.log("任务信息(busTask):", taskDetail.busTask);
          // 设置任务时长
          if (taskDetail.busTask.startTime && taskDetail.busTask.endTime) {
            const startDate = taskDetail.busTask.startTime.split(' ')[0] + ' 00:00:00';
            const endDate = taskDetail.busTask.endTime.split(' ')[0] + ' 00:00:00';
            this.updateForm.date = [startDate, endDate];
          }
          // 设置班组
          if (taskDetail.busTask.groupId) {
            this.updateForm.groupId = taskDetail.busTask.groupId;
            // 保存原始班组信息
            this.originalGroupInfo = {
              groupId: taskDetail.busTask.groupId,
              groupManageId: item.groupManageId,
              groupManageName: item.groupManageName,
              groupName: item.groupName
            };
            // 初始化表单中的班组信息
            this.updateForm.groupManageId = item.groupManageId;
            this.updateForm.groupManageName = item.groupManageName;
            this.updateForm.groupName = item.groupName;
          }
        }
      });
      // 显示弹窗
      this.updateDialogVisible = true;
      console.log(this.updateForm);
      
    },
    // 获取班组列表
    getGroupList() {
      TeamGroupApi.getGroupInfo().then((res) => {
        if (res.data.code === 200) {
          this.groupList = res.data.data;
        }
      });
    },
    // 班组选择变化
    changeGroup(val) {
      // 获取班组信息
      const selectedGroup = this.groupList.find(item => item.id === val);
      if (selectedGroup) {
        this.updateForm.groupName = selectedGroup.name;
      }
      // 获取班组长信息
      this.getGroupPeople(val);
      // 获取该班组的可用车辆
      this.getGroupCars(val);
      
    },
    // 获取班组长信息
    getGroupPeople(groupId) {
      TeamGroupApi.getEmployeeByGroupId({
        groupId: groupId,
        employeeInfos: '',
        pageDto: {
          current: 0,
          size: 10000,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          res.data.data.records.forEach((item) => {
            // 1 班组组长
            if (item.managerMark === 1) {
              this.updateForm.groupManageId = item.id;
              this.updateForm.groupManageName = item.name;
            }
          });
        }
      });
    },
    // 获取班组车辆
    getGroupCars(groupId) {
      this.carList = []; // 先清空车辆列表
      TaskDispatchApi.listCar({
        current: 0,
        groupId: groupId,
        size: 1000,
        startTime: this.updateForm.date[0].substring(0, 10) + ' 00:00:00',
        endTime: this.updateForm.date[1] ? this.updateForm.date[1].substring(0, 10) + ' 23:59:59' : ''
      }).then((res) => {
        if (res.data.code === 200) {
          res.data.data.forEach((item) => {
             if (item.usageStatus === 0) { // 只添加可用状态(usageStatus为0)的车辆
            this.carList.push(item);
             }
          });
        }
      });
    },
    // 打开车辆选择对话框
    addCar() {
      if (this.updateForm.date.length != 2) {
        this.$message({
          message: '请先选择任务时长',
          type: 'error',
        });
        return;
      }
      this.carVisible = true;
      this.getCar2();
    },
    // 选择车辆类型
    chooseCarType(val) {
      this.type = val;
      this.getCar2();
    },
    // 获取可选择的车辆
    getCar2() {
      TaskDispatchApi.listCar({
        current: 0,
        carMark: this.type,
        size: 1000,
        startTime: this.updateForm.date[0],
        endTime: this.updateForm.date[1],
      }).then((res) => {
        if (res.data.code === 200) {
          this.addCarList = res.data.data;
        }
      });
    },
    // 选择车辆
    chooseCar(index, item) {
      if (item.usageStatus === 0) {
        this.selectCar = this.addCarList[index];
      }
    },
    // 确认添加车辆
    submitCar() {
      if (JSON.stringify(this.selectCar) === '{}') {
        this.$message({
          message: '请选择车辆',
          type: 'error',
        });
        return;
      }
      if (
        !this.carList.some((item) => {
          return item.carId === this.selectCar.carId;
        })
      ) {
        this.carList.push(JSON.parse(JSON.stringify(this.selectCar)));
      }
      this.carVisible = false;
      this.$nextTick(() => {
        this.selectCar = {};
      });
    },
    // 删除车辆
    delCar(index) {
      this.carList.splice(index, 1);
    },
    // 关闭对话框
    closeDialog() {
      this.carVisible = false;
    },
    // 确认更新
    confirmUpdate() {
      if (!this.updateForm.date || this.updateForm.date.length !== 2) {
        this.$message.warning("请选择任务时长");
        return;
      }
      if (!this.updateForm.groupId) {
        this.$message.warning("请选择班组");
        return;
      }

      const params = {
        taskId: this.currentTask.id,
        startTime: this.updateForm.date[0],
        endTime: this.updateForm.date[1],
        groupId: this.updateForm.groupId,
        groupManageId: this.updateForm.groupManageId, 
        groupManageName: this.updateForm.groupManageName,
        groupName: this.updateForm.groupName,
        carDtos: this.carList     
      };
      console.log(params);
      

      TaskDispatchApi.updateTask(params).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.updateDialogVisible = false;
          this.getTaskList(); // 刷新任务列表
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    truncateText(text) {
      if (!text) return "";
      return text.length > 10 ? text.substring(0, 10) + "..." : text;
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      console.log(key, keyPath);
    },
    goToTaskDetail(item) {
      this.$router.push(
        "/taskDispatchDetail?id=" + item.id + "&pid=" + this.$route.query.id,
      );
    },
    // 导出作业汇总表
    async exportTaskSummary(item) {
      let loadingInstance = null;
      try {
        loadingInstance = this.$loading({
          lock: true,
          text: '正在导出作业汇总表...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        // 获取任务详情（包含所有作业数据）
        const res = await TaskDispatchApi.getTaskDetail({
          current: 1,
          size: 9999,
          taskId: item.id,
          projectId: this.$route.query.id
        });

        if (!res || !res.data) {
          this.$message.error('获取任务详情失败：无响应数据');
          return;
        }

        if (res.data.code !== 200) {
          this.$message.error(res.data.msg || '获取任务详情失败');
          return;
        }

        const taskDetail = res.data.data;
        if (!taskDetail) {
          this.$message.error('任务详情数据为空');
          return;
        }

        const busTaskItems = taskDetail.busTaskItems || [];

        if (busTaskItems.length === 0) {
          this.$message.warning('该任务暂无作业数据');
          return;
        }

        // 状态映射
        const statusMap = {
          0: '未开始',
          1: '进行中',
          2: '已完成',
          3: '已取消'
        };

        // 组装导出数据
        const exportData = busTaskItems.map((work, index) => ({
          seq: index + 1,
          workDate: work.workDate || '',
          description: work.description || '',
          checkInTime: work.checkInTime || '',
          checkOutTime: work.checkOutTime || '',
          checkInAddress: work.checkInAddress || '',
          checkOutAddress: work.checkOutAddress || '',
          status: statusMap[work.status] || work.status || ''
        }));

        // 表头映射
        const fields = {
          seq: '序号',
          workDate: '作业日期',
          description: '工作描述',
          checkInTime: '签到时间',
          checkOutTime: '签退时间',
          checkInAddress: '签到地址',
          checkOutAddress: '签退地址',
          status: '状态'
        };

        // 调用导出函数
        const { xlsx } = await import('@/utils/xlsx.js');
        xlsx(exportData, fields, `${item.workName || '任务'}_作业汇总表.xlsx`);

        this.$message.success('导出成功');
      } catch (error) {
        console.error('导出失败:', error);
        const errorMsg = (error.response && error.response.data && error.response.data.msg) || error.message || '导出失败，请重试';
        this.$message.error(errorMsg);
      } finally {
        if (loadingInstance) loadingInstance.close();
      }
    },
    getDetail() {
      TaskDispatchApi.getProjectDetail({
        projectId: this.$route.query.id,
        current: 0,
        size: 10,
      }).then((res) => {
        if (res.data.code === 200) {
          console.log("--", this.$route.query.id);
          console.log("项目详情", res);
          this.info = res.data.data.busProject;
          this.detail = res.data.data;
          this.listType = res.data.data.busProjectRoads;
          this.listType.push({
            id: "",
            projectId: "",
            roadId: "",
            roadName: "总计",
          });

          // 初始化项目年度信息（方案A）
          if (this.yearScheme === 'a') {
            // 如果项目有年度字段，使用项目年度
            if (this.info.year) {
              this.projectYear = this.info.year;
            } else {
              // 否则从项目周期中提取年度
              if (this.info.startDate && this.info.endDate) {
                const startYear = new Date(this.info.startDate).getFullYear();
                const endYear = new Date(this.info.endDate).getFullYear();
                // 如果项目跨越多年，使用起始年度
                this.projectYear = startYear;
              }
            }
          }

          // 初始状态下不选择任何road，直接加载全部任务
          this.selectRoad = { roadId: "", id: "" ,tag: "all"};
          this.getTaskList();
        }
      });
    },
    getTaskList() {
      TaskDispatchApi.getTaskList({
        roadId: this.selectRoad.roadId,
        current: 0,
        size: 10000,
        projectId: this.$route.query.id,
      }).then((res) => {
        if (res.data.code === 200) {
          // console.log("task");
          // console.log(res);
          this.taskList = res.data.data.busTasks;
          
          // 如果是初始加载（roadId为空），则保存所有任务到AllTasklist
          if (this.selectRoad.roadId === "") {
            this.AllTasklist = [...this.taskList];
          }
          
          console.log("taskList:", this.taskList);
          console.log("AllTasklist:", this.AllTasklist);

          // 为每个任务添加工程量信息
          this.taskList.forEach(task => {
            // 如果任务没有合同类型，默认设置为合同内
            if (!task.contractType) {
              task.contractType = 'in';
            }
            // 初始化工程量数组
            task.busTaskItems = task.busTaskItems || [];
          });

          this.quantityList = res.data.data.busTaskItemQuantities
            ? res.data.data.busTaskItemQuantities
            : [];
          // this.quantityList.push({
          //   workItemName: "架设污水井",
          //   workItemUnitName: "座",
          //   quantity: 12,
          // });
          // this.taskList = this.taskList.push(this.taskList[0]);
          if (this.selectRoad.roadId === "") {
            this.sumList = [];
            this.detail.busProjectItems.forEach((item) => {
              let dic = {
                workItemName: item.workItemName,
                workItemUnitName: item.workItemUnitName,
                jhQuantity: item.quantity,
                quantity: 0,
                workItemId: item.workItemId,
                price: item.price,
              };
              this.quantityList.forEach((subItem) => {
                if (subItem.workItemId === item.workItemId) {
                  dic.quantity = subItem.quantity;
                }
              });
              this.sumList.push(dic);
              // console.log("++>", this.sumList);
            });
          }

          // console.log("task");
        }
      });
    },
    chooseRoad(item) {
      this.selectRoad = item;
      console.log("-->", item);
      // if (item.id != "") {
      this.getTaskList();
      // }
    },
    addTask() {
      // 添加年度方案参数
      let url = "addTask?id=" + this.$route.query.id;
      if (this.yearScheme) {
        url += "&type=" + this.yearScheme;
        if (this.yearScheme === 'a' && this.projectYear) {
          url += "&year=" + this.projectYear;
        } else if (this.yearScheme === 'b' && this.projectYears.length > 0) {
          url += "&years=" + this.projectYears.join(',');
        }
      }
      this.$router.push(url);
    },
    // 年度筛选切换
    handleYearChange(year) {
      this.selectedYear = year;
      console.log('切换到年度:', year);
      // 重新过滤任务列表
      // 触发重新计算 filteredTaskList
    },
    // 显示所有道路和所有类型的任务列表
    showAllTasks() {
      this.selectRoad = { roadId: "" };
      this.activeIndex = "all";
      this.getTaskList();
    },
  },
};
</script>

<style lang="scss" scoped>
.total-class {
  float: right;
  color: #000;
  font-size: 21px;
  font-weight: bold;
  // padding-right: 20px;
}
.total-class-left {
  float: left;
  color: #000;
  font-size: 21px;
  font-weight: bold;
  // padding-right: 20px;
}
.projectDetail {
  min-width: 1100px;
  padding: 10px;
  .top {
    display: flex;
    flex-direction: row;
    height: 80px;
    border-bottom: 1px solid #ccc;
    .icon {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: #d9ecff;
      padding-top: 10px;
      text-align: center;
      flex-shrink: 0;
      flex-grow: 0;
    }
    .content {
      margin-left: 20px;
    }
    .name,
    .time,
    .money,
    .manager {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .name {
      flex: 2.5;
    }
    .time {
      flex: 2;
    }

    .money,
    .manager {
      width: 20%;
      flex: 1;
    }
  }
  .middle {
    height: calc(100% - 80px);
    display: flex;
    flex-direction: row;
    overflow: auto;

    .middleLeft {
      width: 250px;
      .roadItem {
        height: 40px;
        line-height: 40px;
        text-align: right;
        padding-right: 10px;
      }
      .roadItem:hover {
        background-color: rgba(135, 206, 235, 0.7);
      }
      .roadItemChoose {
        background-color: #409eff;
        color: white;
      }
    }
    .middleRight {
      flex: 1;
      border-left: 1px solid #ccc;
      display: flex;
      flex-direction: row;
      .subMiddle {
        flex: 1;
        padding: 0px 20px;
        width: 100%;
        .tab-lead {
          display: flex;
          justify-content: center;
          padding-bottom: 20px;
        }
        .year-filter {
          display: flex;
          align-items: center;
          padding: 10px 0;
          margin-bottom: 15px;
          border-bottom: 1px solid #eee;
          .year-label {
            font-weight: bold;
            margin-right: 10px;
            color: #606266;
          }
          .scheme-tag {
            margin-left: 15px;
            padding: 2px 8px;
            background-color: #409EFF;
            color: white;
            border-radius: 4px;
            font-size: 12px;
          }
        }
        .taskItem {
          width: 48%;
          height: 135px;
          border: 1px solid #ccc;
          border-radius: 10px;
          margin: 10px 0;
          padding: 10px;
        }
        .success {
          border-color: #67c23a;
          color: #67c23a;
        }
        .waring {
          border-color: #e6a23c;
          color: #e6a23c;
        }
        .danger {
          border-color: #656565;
          color: #656565;
        }
        .taskTime {
          color: black;
          height: 20px;
          line-height: 20px;
          padding-left: 35px;
        }
        .taskStatus {
          float: right;
          height: 20px;
          line-height: 20px;
        }
        .taskName {
          width: 100%;
          color: #000;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          height: 40px;
          line-height: 40px;
          font-size: 18px;
          font-weight: 600;
        }
        .task-popover {
          max-width: 400px;
          word-break: break-all;

          .popover-content {
            padding: 10px;
            line-height: 1.5;
            white-space: pre-wrap;
          }
        }
        .taskType {
          color: black;
          height: 20px;
          line-height: 20px;
        }
        .taskTypeName {
          color: black;
          height: 20px;
          line-height: 20px;
          margin-left: auto;
          padding-left: 10px;
        }
        .workInfo {
          height: 40px;
          line-height: 40px;
          font-weight: normal;
          display: flex;
          flex-direction: row;
          .workTitle {
            flex: 3;
          }
          .workUnit {
            flex: 2;
          }
          .workQuantity {
            flex: 1;
            font-size: 26px;
          }
        }
      }
      .subRight {
        width: 450px;
        border-left: 1px solid #ccc;
        padding-left: 20px;
      }
    }
  }
  .title {
    font-weight: 600;
    height: 40px;
    line-height: 40px;
    font-size: 15px;
  }
}
::v-deep .el-col-12 {
  width: 100%;
}

.type {
  width: 100px;
  height: 30px;
  line-height: 30px;
  color: black;
  cursor: pointer;
}

.choose {
  color: #409eff;
}

.gray {
  div {
    color: #ccc;
  }
}

.choosedCar {
  border: 1px solid #409eff !important;
}

.carItem {
  width: 46%;
  height: 60px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;

  .carType {
    float: right;
    height: 30px;
    line-height: 30px;
    margin-right: 10px;
  }

  .carInfo {
    height: 30px;
    line-height: 30px;
    margin-left: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .carNumber {
      font-weight: 600;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }

    .tips {
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      border-radius: 2px;
      color: white;
      margin-left: 4px;
    }

    .success {
      background-color: #67c23a;
    }

    .waring {
      background-color: #e6a23c;
    }

    .danger {
      background-color: #f56c6c;
    }

    .primary {
      background-color: #409eff;
    }
  }

  .carGroup {
    margin-left: 10px;
  }
}

.carItem2 {
  display: inline-block;
  width: 300px;
  height: 60px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 10px;

  .carType {
    float: right;
    height: 30px;
    line-height: 30px;
    margin-right: 10px;
  }

  .carInfo {
    height: 30px;
    line-height: 30px;
    margin-left: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .carNumber {
      font-weight: 600;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }

    .tips {
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      border-radius: 2px;
      color: white;
      margin-left: 4px;
    }

    .success {
      background-color: #67c23a;
    }

    .waring {
      background-color: #e6a23c;
    }

    .danger {
      background-color: #f56c6c;
    }

    .primary {
      background-color: #409eff;
    }
  }

  .carGroup {
    margin-left: 10px;
    height: 30px;
    line-height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}

// 全部年度合计样式
.all-years-summary {
  margin-top: 10px;
  padding-top: 10px;

  .year-item {
    display: flex;
    flex-direction: row;
    padding: 8px 0;
    border-bottom: 1px dashed #eee;

    > div {
      height: auto;
      line-height: 30px;
    }
  }
}

// 合同年度统计样式
.contract-year-summary {
  margin-top: 10px;

  .contract-section {
    margin-bottom: 20px;
    padding: 10px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;

    .section-title {
      font-size: 16px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 10px;
      padding-bottom: 8px;
      border-bottom: 2px solid #409EFF;
    }

    .year-summary-item {
      margin-bottom: 15px;
      padding: 10px;
      background-color: #f5f7fa;
      border-radius: 4px;

      .year-label {
        font-size: 14px;
        font-weight: bold;
        color: #606266;
        margin-bottom: 8px;
      }

      .year-content {
        padding-left: 10px;

        .quantity-item {
          display: flex;
          justify-content: space-between;
          padding: 5px 0;
          border-bottom: 1px dashed #dcdfe6;

          .item-name {
            flex: 2;
            font-size: 13px;
            color: #606266;
          }

          .item-value {
            flex: 1;
            font-size: 13px;
            color: #303133;
            text-align: center;
          }

          .item-price {
            flex: 1;
            font-size: 13px;
            color: #67c23a;
            text-align: right;
          }
        }

        .year-total {
          margin-top: 8px;
          padding-top: 8px;
          font-size: 14px;
          font-weight: bold;
          color: #409EFF;
          text-align: right;
          border-top: 1px solid #dcdfe6;
        }
      }
    }

    .contract-total {
      margin-top: 10px;
      padding: 10px;
      background-color: #ecf5ff;
      border-radius: 4px;
      font-size: 15px;
      font-weight: bold;
      color: #409EFF;
      text-align: right;
    }
  }

  .grand-total {
    margin-top: 15px;
    padding: 15px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 6px;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .grand-total-label {
      font-size: 16px;
      font-weight: bold;
    }

    .grand-total-value {
      font-size: 20px;
      font-weight: bold;
    }
  }
}
</style>
